// Ejemplos con GPS, sensor táctil y láser.
import { part, wires, UNO, at } from './helpers.js';

const BB = { id: 'bb1', type: 'breadboard', x: 0, z: -80, rot: 0, props: { size: 'half' } };

export const EXAMPLES = [
  {
    id: 'gps',
    category: 'Comunicación',
    name: 'GPS: posición y velocidad',
    description: 'El NEO-6M manda frases NMEA por serie y TinyGPS++ las interpreta. Cambia latitud, longitud o velocidad en el panel.',
    project: {
      name: 'GPS NEO-6M',
      files: {
        'sketch.ino': `// GPS NEO-6M con SoftwareSerial y TinyGPS++.
// Selecciona el GPS para cambiar la posición, la velocidad o el número de satélites.
#include <SoftwareSerial.h>
#include <TinyGPSPlus.h>

SoftwareSerial gpsSerial(4, 3);   // RX, TX del Arduino (TX del GPS va al 4)
TinyGPSPlus gps;

void setup() {
  Serial.begin(9600);
  gpsSerial.begin(9600);
  Serial.println("Esperando datos del GPS...");
}

void loop() {
  while (gpsSerial.available()) gps.encode(gpsSerial.read());

  if (gps.location.isUpdated()) {
    Serial.print("Lat: ");
    Serial.print(gps.location.lat(), 6);
    Serial.print("  Lon: ");
    Serial.print(gps.location.lng(), 6);
    Serial.print("  Satélites: ");
    Serial.print(gps.satellites.value());
    Serial.print("  Velocidad: ");
    Serial.print(gps.speed.kmph(), 1);
    Serial.print(" km/h  Hora UTC: ");
    Serial.print(gps.time.hour());
    Serial.print(':');
    if (gps.time.minute() < 10) Serial.print('0');
    Serial.println(gps.time.minute());
  }
}
`,
      },
      parts: [UNO, part('gps1', 'gps-neo6m', {}, { x: 30, z: -78, rot: 0 })],
      wires: wires([
        ['gps1:TX', 'uno:4', 'green'],
        ['gps1:RX', 'uno:3', 'yellow'],
        ['gps1:VCC', 'uno:IOREF', 'red'],
        ['gps1:GND', 'uno:GND.1', 'black'],
      ]),
    },
  },
  {
    id: 'touch-laser',
    category: 'Entradas',
    name: 'Sensor táctil y láser',
    description: 'Al tocar el TTP223 (clic sostenido en el círculo) se enciende el láser KY-008 y se ve su haz.',
    project: {
      name: 'Táctil y láser',
      files: {
        'sketch.ino': `// Mientras tocas el sensor táctil (pin 2) se enciende el láser (pin 7).

const int TACTIL = 2;
const int LASER = 7;

void setup() {
  pinMode(TACTIL, INPUT);
  pinMode(LASER, OUTPUT);
  Serial.begin(9600);
}

void loop() {
  bool tocado = digitalRead(TACTIL) == HIGH;
  digitalWrite(LASER, tocado);
  static bool antes = false;
  if (tocado != antes) {
    Serial.println(tocado ? "Tocado: láser encendido" : "Suelto");
    antes = tocado;
  }
}
`,
      },
      parts: [
        UNO,
        BB,
        part('touch1', 'touch-ttp223', {}, at(BB, 'h6', 'touch-ttp223', { rot: 180, pin: 'VCC' })),
        part('laser1', 'laser-ky008', {}, at(BB, 'c22', 'laser-ky008', { rot: 0, pin: 'S' })),
      ],
      wires: wires([
        ['uno:2', 'bb1:j7', 'yellow'],
        ['bb1:j6', 'bb1:bp4', 'red'],
        ['bb1:j8', 'bb1:bn6', 'black'],
        ['uno:7', 'bb1:a22', 'orange'],
        ['bb1:a24', 'bb1:tn19', 'black'],
        ['uno:5V', 'bb1:bp10', 'red'],
        ['uno:GND.1', 'bb1:bn11', 'black'],
        ['bb1:bn1', 'bb1:tn1', 'black'],
      ]),
    },
  },
];
